import React, { useState, useEffect, useRef } from "react";
import anime from "animejs";

const TeachingStaffHomePageTopAnimation = () => {
  const textRef = useRef(null);
  useEffect(() => {
    const textElement = textRef.current;
    const text = textElement.textContent;
    textElement.innerHTML = text
      .split("")
      .map((char) => `<span class="letter">${char}</span>`)
      .join("");
    anime.timeline({ loop: false }).add({
      targets: ".letter",
      opacity: [0, 1],
      translateY: [20, 0],
      easing: "easeOutExpo",
      duration: 1000,
      delay: (el, i) => i * 50,
    });
  }, []);

  const wavePathRef = useRef(null);

  useEffect(() => {

    anime({
      targets: wavePathRef.current,
      strokeDashoffset: [anime.setDashoffset, 0],
      easing: "easeInOutSine",
      duration: 3000,
      loop: false,
    });
    anime({
      targets: ".wave-container",
      translateY: ["-100%", "100%"],
      easing: "easeInOutQuad",
      duration: 4000,
      loop: true,
    });
  }, []);

  return (
    <div className="w-full">

      <div className="relative flex justify-center items-center w-full py-20 bg-sddarkgray overflow-hidden px-4">
        <div className="flex flex-col items-center justify-center space-y-6 w-full">
          <svg
            className="absolute top-1/2 transform -translate-y-1/2 z-10 p-5"
            width="100%"
            height="100%"
            viewBox="0 0 800 400"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient id="SvgjsLinearGradient1006">
                <stop stopColor="hsl(30, 100%, 50%)" offset="0" />
                <stop stopColor="hsl(30, 100%, 70%)" offset="1" />
              </linearGradient>
            </defs>

            <path
              ref={wavePathRef}
              d="M144.6935577392578,1.7937219142913818C206.8789107767741,24.406575744152068,431.3751794433594,58.235171250502276,450.5231628417969,113.00447845458984C469.67114624023435,167.7737856586774,221.17488006591796,214.74040850321452,238.8639678955078,271.1509704589844C256.55305572509764,327.5615324147542,476.7922192891439,366.1793630981445,537.5186767578125,390.4334716796875"
              fill="none"
              stroke="url(#SvgjsLinearGradient1006)"
              strokeWidth="6"
              strokeLinecap="round"
              strokeDasharray="3000"
            />
          </svg>

          <div className="relative z-20 w-full flex justify-center items-center md:pb-6">
            <div className="inline-block bg-sddarkgray rounded-md">
              <h1
                ref={textRef}
                style={{
                  color: "#ffa600", 
                  textShadow: "0 0 10px rgba(200, 176, 79, 0.715)", 
                }}
                className="text-center text-xl sm:text-2xl lg:text-4xl font-bold"
              >
                Teaching Staff{" "}
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeachingStaffHomePageTopAnimation;
